import { byId, h } from './dom';

/**
 * Toast queue: max 4 visible, identical messages collapse into "×N",
 * stacked bottom-right so they never cover the nest grid (v0.9 pain point).
 */

type Tone = 'info' | 'good' | 'warn' | 'achievement';

interface Live {
  key: string;
  el: HTMLElement;
  count: number;
  timer: number;
  countEl: HTMLElement;
}

const maxVisible = () => (window.matchMedia('(max-width: 900px)').matches ? 2 : 3);
const live: Live[] = [];

function dismiss(t: Live): void {
  const i = live.indexOf(t);
  if (i >= 0) live.splice(i, 1);
  window.clearTimeout(t.timer);
  t.el.classList.add('out');
  window.setTimeout(() => t.el.remove(), 300);
}

export function toast(text: string, tone: Tone = 'info', title?: string, ms = 4500): void {
  const key = `${tone}|${title ?? ''}|${text}`;
  const existing = live.find((t) => t.key === key);
  if (existing) {
    existing.count++;
    existing.countEl.textContent = ` ×${existing.count}`;
    window.clearTimeout(existing.timer);
    existing.timer = window.setTimeout(() => dismiss(existing), ms);
    return;
  }
  const countEl = h('span', { class: 't-count' });
  const el = h('div', { class: `toast ${tone}`, role: 'status' },
    title ? h('div', { class: 't-title' }, title, countEl) : null,
    h('div', {}, text, title ? null : countEl),
  );
  byId('toasts').append(el);
  const entry: Live = { key, el, count: 1, countEl, timer: window.setTimeout(() => dismiss(entry), ms) };
  live.push(entry);
  while (live.length > maxVisible()) dismiss(live[0]!);
}
